export enum FixcenterSupportType {
    OUR_SALES,
    OUR_SUPPORT,
    CALCULATION_PROGRAM,
}
